var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"background":"rgba(28,127,118,0.16)","border":"1px solid","height":"840px","border-image":"linear-gradient(165deg, rgba(44, 139, 131, 0), rgba(77, 241, 227, 1)) 1 1"}})])
}]

export { render, staticRenderFns }